import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clients: [],
};

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    // Додає всіх клієнтів отримані з bd
    addClientsRedux(state, { payload }) {
      state.clients = payload;
      // console.log(payload);
    },
    // Додає нового клієнта
    unshiftClientRedux(state, { payload }) {
      state.clients.unshift(payload);
      // console.log(payload);
    },

    // Видаляє клієнта
    deleteClientRedux(state, { payload }) {
      for (let index = 0; index < state.clients.length; index++) {
        const client = state.clients[index];

        if (payload === client.client_id) {
          state.clients.splice(index, 1);
          break;
        }
      }
    },
    //Додає клієнта в групу
    pushParticipan(state, { payload }) {
      const client_id = payload.client_id;
      const participan_object = payload.participan_object;
      const groupObject_link = payload.groupObject_link;

      for (let index = 0; index < state.clients.length; index++) {
        const item = state.clients[index];
        if (item.client_id === client_id) {
          item.participationGroups[groupObject_link] = participan_object;
          break;
        }
      }
    },
    //Видаляє клієнта з групи
    deleteParticipanRedux(state, { payload }) {
      const client_id = payload.client_id;
      const groupObject_link = payload.groupObject_link;

      for (let index = 0; index < state.clients.length; index++) {
        const item = state.clients[index];
        if (item.client_id === client_id) {
          delete item.participationGroups[groupObject_link];
          break;
        }
      }
    },
    // Додає, забороняє  доступ до меню
    accessToMenuRedux(state, { payload }) {
      const client_id = payload.client_id;
      const groupObject_link = payload.groupObject_link;
      const isAccess = payload.isAccess;
      // participationGroups
      state.clients.forEach((client) => {
        if (client.client_id === client_id) {
          client.participationGroups[groupObject_link].accessGroup = isAccess;
        }
      });
    },
    //Редагує дані клієнта
    editsCustomerDataRedux(state, { payload }) {
      for (let index = 0; index < state.clients.length; index++) {
        const client = state.clients[index];

        if (client.client_id === payload.client_id) {
          state.clients.splice(index, 1, payload);
          break;
        }
      }
    },
    //Чи зберігати дані активності
    toggleSaveActivityListRedux(state, { payload }) {
      const client_id = payload.client_id;
      const isSave = payload.isSave;
      for (let index = 0; index < state.clients.length; index++) {
        const client = state.clients[index];

        if (client.client_id === client_id) {
          state.clients[index].isAddLoginWebList = isSave;
          break;
        }
      }
    },
    //
    editsClientNotesRedux(state, { payload }) {
      const client_id = payload.client_id;
      const notesText = payload.notesText;
      for (let index = 0; index < state.clients.length; index++) {
        const client = state.clients[index];

        if (client.client_id === client_id) {
          state.clients[index].notes = notesText;
          break;
        }
      }
    },
  },
});

export const {
  addClientsRedux,
  unshiftClientRedux,
  pushParticipan,
  deleteParticipanRedux,
  accessToMenuRedux,
  editsCustomerDataRedux,
  editsClientNotesRedux,
  deleteClientRedux,
  toggleSaveActivityListRedux,
} = clientsSlice.actions;

export default clientsSlice.reducer;
